<!-- @format -->

<script>
export default {
    name: 'SSRFallback',
    render() {
        return null;
    },
    created() {
        const route = this.$route;

        this.$router.push({
            name: 'home',
            query: route.query,
            hash: route.hash,
        });
    },
};
</script>
